import { useSEO } from "@/hooks/useSEO";
import { useContent } from "@/context/ContentContext";

const LegalPage = ({ testid, kicker, title, field, seoTitle, seoDesc }) => {
  useSEO({ title: seoTitle, description: seoDesc });
  const { content } = useContent();
  const text = content?.[field] || "";

  return (
    <div data-testid={testid}>
      <section className="bg-[#1F2937] py-20 lg:py-24">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <span className="text-[#FF5A00] font-semibold text-sm uppercase tracking-widest">{kicker}</span>
          <h1 className="mt-3 text-4xl sm:text-5xl font-extrabold tracking-tight text-white">{title}</h1>
        </div>
      </section>
      <section className="py-16 lg:py-24">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          {text.split("\n\n").map((p, i) => (
            <p key={i} className="text-gray-600 text-lg leading-relaxed mb-6 whitespace-pre-line">{p}</p>
          ))}
        </div>
      </section>
    </div>
  );
};

export const Privacy = () => (
  <LegalPage
    testid="privacy-page" kicker="Juridisk" title="Privatlivspolitik" field="privacy_text"
    seoTitle="Privatlivspolitik | AA+PLUS MILJØSANERING"
    seoDesc="Sådan behandler AA+PLUS MILJØSANERING personoplysninger i henhold til GDPR."
  />
);

export const Cookie = () => (
  <LegalPage
    testid="cookie-page" kicker="Juridisk" title="Cookiepolitik" field="cookie_text"
    seoTitle="Cookiepolitik | AA+PLUS MILJØSANERING"
    seoDesc="Information om brug af cookies på AA+PLUS MILJØSANERINGs hjemmeside."
  />
);
